module.exports = __webpack_public_path__ + "static/Lato-Bold-85d339d916479f729938d2911b85bf1f.ttf";